import React from "react";
import "./CardPosition.css";
import { FiShoppingBag, FiShoppingCart, FiCreditCard } from "react-icons/fi";
import { Link } from "react-router-dom";

const steps = [
  { id: 1, label: "Shop", icon: <FiShoppingBag size={25} /> ,link:'/shop'},
  { id: 2, label: "Cart", icon: <FiShoppingCart size={25} /> ,link:'/cart'},
  { id: 3, label: "Checkout", icon: <FiCreditCard size={25} /> ,link:'/CheckOut'},
];

const CardPosition = ({ currentStep = 3 }) => {
  return (
    <div className="stepper">
      {steps.map((step, index) => {
        const isActive = step.id === currentStep;
        const isCompleted = step.id < currentStep;

        return (
          <React.Fragment key={step.id}>
            <Link to={step.link} className={`step ${isActive ? "active" : isCompleted ? "completed" : ""}`}>
              <div className="step-inner">
                <span className="step-view">{step.label}</span>
                {step.icon && <span className="step-icon">{step.icon}</span>}
              </div>
            </Link>

            {/* {index !== steps.length - 1 && (
              <div className={`step-line ${isCompleted ? "line-completed" : ""}`} />
            )} */}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CardPosition;
